import { ContextDictionary } from 'shared/components/hawksearch/models/Recommendation';

//#region Commerce
export function getHawkRecommendationContext(): ContextDictionary {
	return new ContextDictionary(window.__ROC_HAWK_RECOMMENDATION_CONTEXT_OBJECT__);
}
//#endregion

export interface HawkRecommendation {
	Context: ContextDictionary;
	CustomContext: ContextDictionary;
}

declare global {
	interface Window {
		HawkRecommendation: HawkRecommendation;
		__ROC_HAWK_RECOMMENDATION_CONTEXT_OBJECT__?: Record<string, unknown>;
	}
}

const Context = getHawkRecommendationContext();
const CustomContext = new ContextDictionary();

// initialize HawkContext
if (!window.HawkRecommendation) {
	window.HawkRecommendation = {
		Context: Context,
		CustomContext: CustomContext,
	};
}

const HawkRecommendation = window.HawkRecommendation;

export default {
	Context,
	CustomContext,
};
